import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth-store'
import { PERMISSIONS } from '@/lib/rbac/permissions'
import CreateTemplatePage from '@/features/templates/create'

export const Route = createFileRoute('/_authenticated/templates/new')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (!auth.canAccess([PERMISSIONS.MEMES.READ])) {
      throw redirect({
        to: '/403',
      })
    }
  },
  component: () => <CreateTemplatePage />,
})
